import { client } from 'pioneira-ui';
import router from '@/router';
import { v4 as uuid } from 'uuid';
import { handleErrorMsg, removeTimeFromDate } from '../../mixins/storeMixins';

export default {
  namespaced: true,
  state: {
    alertCancel: false,
    alertVeiculoPerfil: false,
    isConfirmingSimulacao: false,
    alertVeiculoPerfilMessage: null,
    loading: false,
    proposta: null,
    currentStep: null,
    stepCounter: 1,
    messages: [],
    proponente: {},
    veiculo: {},
    simulacao: {},
    isReprovada: false,
    cliente_id: null,
    processo_id: null
  },
  mutations: {
    SET_LOADING(state) {
      state.loading = !state.loading;
    },

    SET_NEW_PROPOSTA(state, payload) {
      state.proposta = payload;
    },

    SET_ALERT_CANCEL(state) {
      state.alertCancel = !state.alertCancel;
    },

    TOGGLE_ALERT_CANCEL_VEICULO(state) {
      state.alertVeiculoPerfil = !state.alertVeiculoPerfil;
    },

    TOGGLE_CONFIRM_SIMULACAO(state) {
      state.isConfirmingSimulacao = !state.isConfirmingSimulacao;
    },

    SET_ALERT_CANCEL_VEICULO(state, message) {
      state.alertVeiculoPerfil = !state.alertVeiculoPerfil;
      state.alertVeiculoPerfilMessage = message;
    },

    SET_NEXT_STEP(state, payload) {
      state.currentStep = payload;
    },

    INCREASE_STEP_COUNTER(state) {
      state.stepCounter++;
    },

    PUSH_MESSAGES(state, payload) {
      if (payload.id == undefined) payload.id = uuid();

      state.messages.push(payload);
    },

    SET_PROPONENTE(state, payload) {
      state.proponente = { ...state.proponente, ...payload };
    },

    SET_VEICULO(state, payload) {
      state.veiculo = { ...state.veiculo, ...payload };
    },

    SET_SIMULACAO(state, payload) {
      state.simulacao = payload;
    },

    CLEAR_DATA(state) {
      (state.loading = false),
        (state.currentStep = null),
        (state.proposta = null),
        (state.stepCounter = 1),
        (state.messages = []),
        (state.proponente = {}),
        (state.veiculo = {}),
        (state.simulacao = {});
    },

    RESET_VEICULO(state) {
      (state.currentStep = 'CONDICAO_VEICULO'),
        (state.stepCounter = 2),
        (state.veiculo = {});
    },

    SET_CURRENT_STEP(state, value) {
      state.currentStep = value;
    },

    SET_STEP_COUNTER(state, value) {
      state.stepCounter = value;
    },

    SET_HISTORICO_PROPOSTA_REPROVADA(state, data) {
      state.isReprovada = true;

      if (data.situacao_parceiro === 'veiculo_perfil_invalido') {
        state.stepCounter = 2;
      } else {
        state.stepCounter = 1;
      }

      if (!data.json_data_historico_chat_reprovado) {
        state.messages.push({
          autor: 'sicredi',
          text: 'Nenhum histórico de mensagem',
          id: uuid(),
        });
      } else {
        state.messages = JSON.parse(data.json_data_historico_chat_reprovado);
      }

      state.currentStep = 'FINAL';
    },

    TOGGLE_REPROVADA(state) {
      state.isReprovada = !state.isReprovada;
    },
  },
  getters: {
    currentStep(state) {
      return state.currentStep;
    },
  },
  actions: {
    setHistoricoPropostaReprovada({ commit }, data) {
      commit('CLEAR_DATA');
      commit('SET_HISTORICO_PROPOSTA_REPROVADA', data);
    },

    humanReply(context, payload) {
      context.commit('PUSH_MESSAGES', { autor: 'parceiro', text: payload });
    },

    toggleAlertVeiculoPerfil(context) {
      context.commit('TOGGLE_ALERT_CANCEL_VEICULO');
    },

    botReply(context, payload) {
      context.commit('PUSH_MESSAGES', {
        autor: 'sicredi',
        text: payload.message,
      });

      context.commit('SET_NEXT_STEP', payload.nextStep);
    },

    goBackToCondicaoVeiculo({ dispatch, commit }, message) {
      commit('RESET_VEICULO');

      dispatch('botReply', {
        message: message || 'Escolha um tipo de simulação',
        nextStep: 'CONDICAO_VEICULO',
      });
    },

    async storeHistoricoChatReprovado({ state }, { propostaId, message }) {
      const messages = JSON.parse(JSON.stringify(state.messages));
      messages.push({ autor: 'sicredi', text: message, id: uuid() });

      try {
        await client.patch(
          `/api/csc/propostas/${propostaId}/historico-chat-reprovado`,
          { json_data_historico_chat_reprovado: JSON.stringify(messages) }
        );
      } catch (error) {
        console.log(error);
      }
    },

    async handleValidateVeiculoError({ dispatch, commit }, error) {
      const err = error.response;

      if (!err.data && err.data.data) {
        return;
      }

      const data_holder = err.data.data.codigo
        ? err.data.data.codigo
        : err.data.data.code;

      if (['30', '31', '41', '412', '46'].includes(data_holder)) {
        let message = err.data.message;

        if (data_holder == '41') {
          dispatch('goBackToCondicaoVeiculo', message);
        } else {
          if (data_holder == '30') {
            message = `<span>O tempo limite desta etapa foi atingido ou não foram encontrados processos com intervalo de tempo válido, o processo será <strong>reiniciado</strong>.</span>`;
          } else if (data_holder == '31') {
            dispatch('goBackToCondicaoVeiculo', message);
          } else if (data_holder == '46' || data_holder == '412') {
            if (data_holder == '46') {
              message = `Não é possível avançar com a contratação de crédito para este veículo, pois o mesmo se encontra fora do perfil de financiamento. Realize uma nova simulação considerando outro veículo.`;
            }

            if (err.data.data.propostaId) {
              await dispatch('storeHistoricoChatReprovado', {
                propostaId: err.data.data.propostaId,
                message,
              });
            }

            dispatch('botReply', {
              message: message,
              nextStep: 'FINAL',
            });

            return;
          }

          commit('CLEAR_DATA');
          dispatch('botReply', {
            message: message,
            nextStep: 'CPF',
          });

          context.commit('SET_LOADING');

          setTimeout(() => {
            commit('PUSH_MESSAGES', {
              autor: 'sicredi',
              text: 'Vamos começar! Informe o <strong>CPF</strong> do proponente',
            });
          }, 1500);
        }
      } else {
        const message = handleErrorMsg(err.data.message, 'placa');
        dispatch('goBackToCondicaoVeiculo', message);
      }
    },

    runChat(context, payload) {
      if (context.state.currentStep == 'CPF') {
        context.dispatch('validateCPF', payload);
      } else if (context.state.currentStep == 'CIDADE') {
        context.dispatch('validateCidade', payload);
      } else if (context.state.currentStep == 'CONDICAO_VEICULO') {
        context.dispatch('validateCondicaoVeiculo', payload);
      } else if (context.state.currentStep == 'VEICULO_NOVO') {
        context.dispatch('validateVeiculoNovo', payload);
      } else if (context.state.currentStep == 'VEICULO_USADO') {
        context.dispatch('validateVeiculoUsado', payload);
      }
    },

    initChat(context) {
      if (context.state.isReprovada) {
        context.commit('TOGGLE_REPROVADA');
        return;
      }

      context.commit('CLEAR_DATA');
      context.commit('SET_NEXT_STEP', 'CPF');

      setTimeout(() => {
        context.commit('PUSH_MESSAGES', {
          autor: 'sicredi',
          text: 'Vamos começar! Informe o <strong>CPF</strong> do proponente',
        });
      }, 200);
    },

    validateCPF(context, payload) {
      context.dispatch('humanReply', `<span>${payload}</span>`);
      context.commit('SET_PROPONENTE', { cpf: payload });
      context.commit('SET_LOADING');

      client
        .post('/api/simulacoes/cpf', { cpf: payload })
       // .post('/api/simulacoes/clientes/cpf', { cpf: payload }) 
        .then(({ data }) => {
          context.commit('SET_LOADING');
          console.log(data.data);
          if (data.success) {
            console.log('Processo ID recebido do backend:', data.data.processo_id);
            context.commit('SET_PROPONENTE', {
              nome: data.data.nome,
              associado: data.data.associado,
              habilitado: data.habilitado,
              cliente_id: data.data.cliente_id,
              processo_id: data.data.processo_id
            });

            console.log('CONTEXT: ', context);

            if (data.message === 'Cpf habilitado.') {
              if (data.data.associado) {
                context.dispatch('botReply', {
                  message: `<span>Que ótimo,<strong> ${context.state.proponente.nome} </strong>já é um associado do Sicredi e esse CPF <strong>está habilitado</strong> para solicitação de crédito veicular.<br />Agora nos diga qual é o <strong>tipo de simulação</strong> que deseja realizar</span>`,
                  nextStep: 'CONDICAO_VEICULO',
                });

                context.commit('INCREASE_STEP_COUNTER');
              } else {
                context.dispatch('botReply', {
                  message: `<span><strong> ${context.state.proponente.nome} </strong> ainda <strong>não é</strong> um associado do Sicredi. Esse CPF <strong>está habilitado</strong> para solicitação de crédito veicular.<br />Agora informe a <strong>cidade</strong> que ${context.state.proponente.nome} <strong>reside</strong> ou <strong>trabalha</strong></span>`,
                  nextStep: 'CIDADE',
                });
              }
            } else {
              let message = context.state.proponente.associado
                ? `<span><strong> ${
                    context.state.proponente.nome || payload
                  } </strong> já é um associado do Sicredi, mas esse CPF <strong>não está habilitado</strong> para solicitação de crédito veicular</span>`
                : `<span><strong> ${
                    context.state.proponente.nome || payload
                  } </strong> ainda <strong>não é</strong> um associado do Sicredi. Esse CPF <strong>não está habilitado</strong> para solicitação de crédito veicular</span>`;

              context.dispatch('botReply', {
                message: message,
                nextStep: 'FINAL',
              });
            }
          } else {
            context.dispatch('botReply', {
              message: `<span>Desculpe, não encontramos o CPF informado. Por favor, tente novamente</span>`,
              nextStep: 'CPF',
            });
          }
        })
        .catch(async (error) => {
          let message = '';

          const hasData = error.response.data && error.response.data.data;

          if (hasData) {
            message = error.response.data.data.associado
              ? `<span><strong> ${
                  error.response.data.data.nome || payload
                } </strong> já é um associado do Sicredi, mas esse CPF <strong>não está habilitado</strong> para solicitação de crédito veicular</span>`
              : `<span><strong> ${
                  error.response.data.data.nome || payload
                } </strong> ainda <strong>não é</strong> um associado do Sicredi. Esse CPF <strong>não está habilitado</strong> para solicitação de crédito veicular</span>`;

            if (error.response.data.data.propostaId) {
              await context.dispatch('storeHistoricoChatReprovado', {
                propostaId: error.response.data.data.propostaId,
                message,
              });
            }

            if (
              error.response.data.data.codigo &&
              ['53', '60', '61', '62'].includes(error.response.data.data.codigo)
            ) {
              message = handleErrorMsg(
                error.response.data.message,
                'cpf',
                error.response.data
              );
            }

            context.commit('PUSH_MESSAGES', {
              autor: 'sicredi',
              text: message,
            });

            context.commit('SET_NEXT_STEP', 'FINAL');
          } else {
            if (error.response.data.message === 'CPF com formato inválido.') {
              message = `Vamos tentar de novo! Não localizamos o CPF <b>${context.state.proponente.cpf}</b> em nossa base. Por favor, revise o número e digite-o novamente`;
            } else {
              message = handleErrorMsg(error.response.data.message, 'CPF');
            }

            context.commit('PUSH_MESSAGES', {
              autor: 'sicredi',
              text: message,
            });

            context.dispatch('botReply', {
              message:
                'Vamos começar! Informe o <strong>CPF</strong> do proponente',
              nextStep: 'CPF',
            });
          }

          context.commit('SET_LOADING');
        });
    },

    validateCidade(context, payload) {
      context.commit('SET_PROPONENTE', { cidade: payload });
      context.dispatch('humanReply', `<span>${payload}</span>`);

      setTimeout(() => {
        context.dispatch('botReply', {
          message:
            '<span>A <strong>Sicredi Pioneira</strong> atende nessa região! Agora nos diga qual é o <strong>tipo de simulação</strong> que deseja realizar</span>',
          nextStep: 'CONDICAO_VEICULO',
        });
      }, 500);

      context.commit('INCREASE_STEP_COUNTER');
    },

    validateCondicaoVeiculo(context, payload) {
      context.commit('SET_VEICULO', { condicao: payload });

      if (payload == 'NOVO') {
        context.dispatch('humanReply', `<span>Simular pela Fipe</span>`);

        setTimeout(() => {
          context.dispatch('botReply', {
            message:
              '<span>Estamos quase lá! Informe a <strong>marca, modelo e ano</strong> desse veículo</span>',
            nextStep: 'VEICULO_NOVO',
          });
        }, 500);

        context.commit('INCREASE_STEP_COUNTER');
      } else if (payload == 'USADO') {
        context.dispatch('humanReply', `<span>Simular pela Placa</span>`);

        setTimeout(() => {
          context.dispatch('botReply', {
            message:
              '<span>Estamos quase lá! Informe a <strong>placa</strong> desse veículo</span>',
            nextStep: 'VEICULO_USADO',
          });
        }, 500);

        context.commit('INCREASE_STEP_COUNTER');
      }
    },

    async getVeiculoUsadoInfo({ commit, state }) {
      commit('SET_LOADING');

      try {
        const { data } = await client.get(
          `/api/simulacoes/veiculo/usado-info?
            placa=${state.veiculo.placa.toUpperCase()}&
            ano=${state.veiculo.ano}&
            cod=${state.veiculo.codigo_fipe}`
        );

        return data;
      } catch ({ response }) {
        return response.data;
      } finally {
        commit('SET_LOADING');
      }
    },

    getAutocorpVeiculo(context, veiculoUsadoInfo) {
      context.commit('TOGGLE_CONFIRM_SIMULACAO');

      const dadosPost = {
        placa: context.state.veiculo.placa.toUpperCase(),
        cpf: context.state.proponente.cpf,
        proposta_id: context.state.proposta,
        codigo_fipe: context.state.veiculo.codigo_fipe,
        ano: context.state.veiculo.ano,
        associado: context.state.proponente.associado,
        veiculo: veiculoUsadoInfo,
        processo_id: context.state.proponente.processo_id 
      };

      client
        .post('/api/simulacoes/troca-usado', dadosPost)
        .then(({ data }) => {
          context.commit('TOGGLE_CONFIRM_SIMULACAO');

          if (data.success) {
            context.commit('SET_VEICULO', {
              marca: data.data.marca || '-',
              modelo: data.data.modelo || '-',
              ano: data.data.ano_modelo || '-',
              ano_fabricacao: data.data.ano_fabricacao || '-',
              renavam: data.data.renavam || '-',
              uf_veiculo: data.data.uf_veiculo || '-',
              chassi: data.data.chassi || '-',
              cor: data.data.cor || '-',
              valor: data.data.valor_fipe || '-',
            });
          }

          if (context.state.simulacao.pessoa.associado) {
            router.push(
              '/propostas/contratacao/acompanhamento/' +
                context.state.proposta +
                '/0'
            );
          } else {
            router.push('/propostas/contratacao/' + context.state.proposta);
          }
        })
        .catch((error) => {
          const responseData = error.response && error.response.data;

          if (responseData && responseData.code === 422 && typeof responseData.error === 'string' && responseData.error.includes('veiculo.renavam')) {
            context.commit('SET_ALERT_CANCEL_VEICULO', "O campo RENAVAM está vazio ou foi preenchido com um formato inválido.");
          }
          else if (responseData && responseData.data && responseData.data.codigo == 40) { 
            context.commit('SET_ALERT_CANCEL_VEICULO'); 
          }
          else {
            context.commit(
              'SET_ALERT_CANCEL_VEICULO',
              'Ops, parece que houve uma falha técnica. Por favor, tente repetir a operação em alguns minutos'
            );
          }
          context.commit('TOGGLE_CONFIRM_SIMULACAO');
        });
    },

    validateVeiculoUsado(context, payload) {
      context.commit('SET_VEICULO', { placa: payload });
      context.commit('SET_LOADING');
      context.dispatch('humanReply', `<span>${payload.toUpperCase()}</span>`);

      // const cliente_id = context.state.proponente?.cliente_id;
      // const processo_id = context.state.proponente?.processo_id;
      // console.log(context.state.proponente.cliente_id);

      const dadosPost = {
        placa: payload.toUpperCase(),
        cpf: context.state.proponente.cpf,
        nome: context.state.proponente.nome,
        associado: context.state.proponente.associado,
        sexo: context.state.proponente.sexo,
        veiculo_tipo: 'USADO',
        processo_id: context.state.proponente.processo_id 
      };

     /*
      const dadosPost = {
        placa: payload.toUpperCase()
      } */

     // const uri = `/api/simulacoes/clientes/${cliente_id}/processos/${processo_id}/validar-veiculo-usado`;

      client
        .post('/api/simulacoes/veiculo', dadosPost)
     //   .post(uri, dadosPost)
        .then(({ data }) => {
          context.commit('SET_LOADING');

          if (data.success) {
            context.commit('SET_VEICULO', {
              marca: data.data.MARCA || '-',
              modelo: data.data.MODELO || '-',
              ano: data.data.ANO_MODELO || '-',
              ano_fabricacao: data.data.ANO_FABRICACAO || '-',
              renavam: data.data.RENAVAM || '-',
              uf_veiculo: data.data.UF || '-',
              chassi: data.data.CHASSI || '-',
              cor: data.data.COR || '-',
              valor: data.data.PRECO || '-',
            });

            let reply = `<table>
              <td colspan="2" class="pb-4">Dados do Veículo</td>
              <tr>
                <td class="pr-4">
                  Marca:
                  <strong>${context.state.veiculo.marca}</strong>
                </td>
              </tr>
              <tr>
                <td class="pr-4">
                  Ano/Modelo:
                  <strong>${context.state.veiculo.ano_fabricacao || ''}/${
              context.state.veiculo.ano || ''
            }</strong>
                </td>
              </tr>
              <tr>
                <td class="pr-4">
                  Tabela FIPE:
                  <strong>R$ ${context.state.veiculo.valor}</strong>
                </td>
              </tr>
            </table>`;

            context.dispatch('botReply', {
              message: reply,
              nextStep: 'SIMULACAO',
            });

            context.commit('INCREASE_STEP_COUNTER');
          } else {
            const message =
              error.response.data.data.includes('code') &&
              error.response.data.data.codigo
                ? '<span>Localizamos o veículo! Mas ele <strong>não está habilitado</strong> para solicitação de crédito veícular</span>'
                : '<span>Não é possível avançar com a contratação de crédito para este veículo, pois o mesmo se encontra fora do perfil de financiamento. Realize uma nova simulação considerando outro veículo.</span>';

            context.dispatch('botReply', {
              message: message,
              nextStep: 'FINAL',
            });

            context.commit('INCREASE_STEP_COUNTER');
          }
        })
        .catch(async (error) => {
          await context.dispatch('handleValidateVeiculoError', error);
          context.commit('SET_LOADING');
        });
    },

    validateVeiculoNovo(context, payload) {
      // const cliente_id = context.state.proponente?.cliente_id;
      // const processo_id = context.state.proponente?.processo_id;

      const ano = {
        fabric: payload.ano_fabricacao ? `${payload.ano_fabricacao}/` : '',
        modelo: payload.ano.text || '0km',
      };

      let reply = `<p style="text-align: right">Marca <strong>
        ${payload.marca.text}</strong><br /><strong>
        ${payload.modelo.text}</strong><br />Ano/Modelo: <strong>
        ${ano.fabric + ano.modelo}</strong></p>`;

      context.dispatch('humanReply', reply);
      context.commit('SET_LOADING');
      
      const dadosPost = {
        ano: payload.ano.value,
        codigo_fipe: payload.modelo.value,
        cpf: context.state.proponente.cpf,
        veiculo_tipo: 'NOVO',
        cpf: context.state.proponente.cpf,
        nome: context.state.proponente.nome,
        associado: context.state.proponente.associado,
        sexo: context.state.proponente.sexo,
        processo_id: context.state.proponente.processo_id 
      };

      /*
      const dadosPost = {
        ano_modelo: payload.ano.value,
        codigo_fipe: payload.modelo.value,
      };
      */
      // const uri = `/api/simulacoes/clientes/${cliente_id}/processos/${processo_id}/validar-veiculo-novo`;

      client
        .post('/api/simulacoes/veiculo', dadosPost)
       // .post(uri, dadosPost)
        .then((response) => {
          context.commit('SET_LOADING');

          let veiculo = {
            marca: response.data.data.MARCA,
            modelo: response.data.data.MODELO,
            codigo_fipe: payload.modelo.value,
            ano: response.data.data.ANO_MODELO,
            valor: response.data.data.PRECO,
          };

          context.commit('SET_VEICULO', veiculo);

          if (response.status) {
            context.dispatch('botReply', {
              message: `<span>Localizamos o veículo! O valor contido na Tabela FIPE é de <strong>${veiculo.valor.toLocaleString(
                'pt-br',
                { style: 'currency', currency: 'BRL' }
              )}</strong></span>`,
              nextStep: 'SIMULACAO',
            });

            context.commit('INCREASE_STEP_COUNTER');
          } else {
            context.dispatch('getBotResponse', {
              message:
                '<span>Localizamos o veículo! Mas ele <strong>não está habilitado</strong> para solicitação de crédito veícular</span>',
              nextStep: 'FINAL',
            });

            context.commit('INCREASE_STEP_COUNTER');
          }
        })
        .catch(async (error) => {
          await context.dispatch('handleValidateVeiculoError', error);
          context.commit('SET_LOADING');
        });
    },

    simulacaoSaveSecondPage(context) {
      client.post('/api/simulacoes/salvar-simulacao', context.state.veiculo, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },

    updatePropostaAcompanhamento(context) {
      return client.patch(
        `/api/acompanhamento/proposta/${context.state.proposta}`,
        {
          veiculo: context.state.veiculo,
        }
      );
    },

    simulacaoConclusion(context) {
      context.commit('TOGGLE_CONFIRM_SIMULACAO');
      const dadosPost = {
        associado: context.state.proponente.associado,
        cpf: context.state.proponente.cpf,
        proposta_id: context.state.proposta,
        veiculo: context.state.veiculo,
      };
      console.log(dadosPost);
      client
        .post('/api/simulacoes/finalizar-simulacao', dadosPost, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(({ data }) => {
          context.commit('TOGGLE_CONFIRM_SIMULACAO');

          if (context.state.simulacao.pessoa.associado) {
            router.push(
              '/propostas/contratacao/acompanhamento/' +
                context.state.proposta +
                '/0'
            );
          } else {
            router.push('/propostas/contratacao/' + context.state.proposta);
          }
        })
        .catch((error) => {
          context.commit('TOGGLE_CONFIRM_SIMULACAO');
          const responseData = error.response && error.response.data;
        
          if (responseData && responseData.code === 422 && typeof responseData.error === 'string' && responseData.error.includes('veiculo.renavam')) {
            context.commit('SET_ALERT_CANCEL_VEICULO', "O campo RENAVAM está vazio ou foi preenchido com um formato inválido.");
          }
          else if (responseData && responseData.data) {
            const nestedData = responseData.data;
            if (nestedData.codigo == '40') { 
              context.commit('SET_ALERT_CANCEL_VEICULO');
            } else if (nestedData.code && ['61', '62'].includes(String(nestedData.code))) { 
              context.commit(
                'SET_ALERT_CANCEL_VEICULO',
                'Ops, parece que houve uma falha técnica. Por favor, tente repetir a operação em alguns minutos'
              );
            } else {
              context.commit(
                'SET_ALERT_CANCEL_VEICULO',
                'Ops, parece que houve uma falha técnica. Por favor, tente repetir a operação em alguns minutos'
              );
            }
          }
          else {
            context.commit(
              'SET_ALERT_CANCEL_VEICULO',
              'Ops, parece que houve uma falha técnica. Por favor, tente repetir a operação em alguns minutos'
            );
          }
        });
    },

    finishSimulacao(context) {
      context.commit('SET_LOADING');
      let extraData = {};

      if (context.state.veiculo.condicao == 'NOVO') {
        extraData = {
          codigo_fipe: context.state.veiculo.codigo_fipe,
          ano: context.state.veiculo.ano,
        };
      } else {
        extraData = {
          placa: context.state.veiculo.placa,
        };
      }

      if (context.state.proposta) {
        extraData = {
          proposta_id: context.state.proposta,
          ...extraData,
        };
      }

      const processo_id = context.state.proponente.processo_id;

      const dadosPost = {
        cpf: context.state.proponente.cpf,
        processo_id: processo_id,
        veiculo_tipo: context.state.veiculo.condicao,
        ...extraData,
      };

      client
        .post('/api/simulacoes/clientes/calcular-proposta', dadosPost, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(({ data }) => {
          context.commit('SET_SIMULACAO', data.data);
          context.commit('SET_NEW_PROPOSTA', data.data.proposta_id);
          context.commit('SET_LOADING');
          context.commit('INCREASE_STEP_COUNTER');
          router.push('/propostas/resultado-simulacao');
        })
        .catch(async (e) => {
          context.commit('SET_LOADING');
          
          const errorData = e.response && e.response.data ? e.response.data : {};
          
          const errorCode = errorData.data && (errorData.data.code || errorData.data.codigo);
          let message = handleErrorMsg(errorData.message || 'Erro na simulação', 'simulação');
          
          const codigosReprovacao = ['53', '54', '60', '61', '62', '46', '412'];
          
          if (errorCode && codigosReprovacao.includes(errorCode)) {
            
            const propostaId = errorData.data && errorData.data.id;
            
            if (propostaId) {
              try {
                await context.dispatch('storeHistoricoChatReprovado', {
                  propostaId: propostaId,
                  message,
                });
                
                context.commit('SET_NEW_PROPOSTA', propostaId);
                
                context.dispatch('botReply', {
                  message: message,
                  nextStep: 'FINAL',
                });
                
                context.commit('TOGGLE_REPROVADA');
              } catch (error) {
                context.dispatch('goBackToCondicaoVeiculo', message);
              }
            } else {
              context.dispatch('goBackToCondicaoVeiculo', message);
            }
          } else {
            // Para outros erros, voltar para a condição do veículo
            context.dispatch('goBackToCondicaoVeiculo', message);
          }
        });
    },

    veiculoForaPerfil(context) {
      context.commit('SET_ALERT_CANCEL_VEICULO');
    },

    quitSimulacaoFinalizada(context) {
      context.commit('SET_ALERT_CANCEL_VEICULO');
      router.push('/propostas/nova-simulacao');
    },

    quitSimulacao(context, stage) {
      if (stage == 1) {
        context.commit('SET_ALERT_CANCEL');
      } else if (stage == 2) {
        context.commit('CLEAR_DATA');
        context.commit('SET_ALERT_CANCEL');
        router.go('/propostas/nova-simulacao');
      }
    },

    changeVeiculo(context) {
      context.commit('RESET_VEICULO');
    },

    async apiMotor(context, payload) {
      context.commit('SET_LOADING');
      let extraData = {};
      const processo_id = context.state.proponente.processo_id;

      if (context.state.veiculo.condicao == 'NOVO') {
        extraData = {
          ano: context.state.veiculo.ano,
          codigo_fipe: context.state.veiculo.codigo_fipe,
        };
      } else {
        extraData = {
          placa: context.state.veiculo.placa,
        };
      }

      if (context.state.proposta) {
        extraData = {
          proposta_id: context.state.proposta,
          ...extraData,
        };
      }

      const dadosPost = {
        cpf: context.state.proponente.cpf,
        processo_id: processo_id,
        veiculo_tipo: context.state.veiculo.condicao,
        frota: payload.frota,
        parcela_quantidade: payload.parcelas,
        forma_pagamento: payload.forma_pagamento,
        primeira_parcela: payload.primeira_parcela,
        valor_financiado: payload.valor_financiado,
        ...extraData,
      };

      const response = await client
      //  .post('/api/simulacoes/recalcular-proposta', dadosPost, {
        .post('/api/simulacoes/clientes/recalcular-proposta', dadosPost, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(({ data }) => {
          context.commit('SET_SIMULACAO', data.data);
          context.commit('SET_LOADING');
          return data;
        })
        .catch((e) => {
          context.commit('SET_LOADING');
          const message = handleErrorMsg(e.response.data.message, 'simulação');
          context.dispatch('goBackToCondicaoVeiculo', message);
          return e.response.data;
        });

      return response;
    },

    async accessEditResultadoSimulacao({ commit, dispatch }, proposta) {
      commit('SET_CURRENT_STEP', 'SIMULACAO');
      commit('SET_STEP_COUNTER', 5);
      commit('SET_NEW_PROPOSTA', proposta.id);
      
      commit('SET_PROPONENTE', {
        ...proposta.proponente,
        processo_id: proposta.processo_id
      });
    
      commit('SET_VEICULO', {
        condicao: proposta.veiculo.placa ? 'USADO' : 'NOVO',
        chassi: proposta.veiculo.chassi,
        placa: proposta.veiculo.placa,
        valor: proposta.veiculo.valor_fipe,
        uf_alienacao: proposta.veiculo.uf_alienacao,
        uf_veiculo: proposta.veiculo.uf_veiculo,
        renavam: proposta.veiculo.renavam,
        cor: proposta.veiculo.cor,
        ano: proposta.veiculo.ano_modelo,
        modelo: proposta.veiculo.modelo,
        ano_fabricacao: proposta.veiculo.ano_fabricacao,
        codigo_fipe: proposta.veiculo.codigo_fipe,
      });

      const data = {
        frota: proposta.frota,
        parcelas: proposta.numero_parcelas,
        primeira_parcela: removeTimeFromDate(proposta.data_primeira_parcela),
        valor_financiado: parseFloat(proposta.valor_solicitado),
        forma_pagamento: proposta.forma_pagamento,
      };

      const response = await dispatch('apiMotor', data);
      if (!!response.success) router.push('/propostas/resultado-simulacao');
      return response;
    },
  },
};
